// extracted by mini-css-extract-plugin
export default {"currencyInputInfoCallout":"currencyInputInfoCallout","alert":"alert"};